<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CART_ITEM_LIST')">
        <slot name="section-cart-item-list">
          <section-cart-item-list ref="CART_ITEM_LIST"
                                  id="CART_ITEM_LIST"
                                  :extended="isExtended('CART_ITEM_LIST')"
                                  :showButton="true"
                                  :autoSave="true"
                                  :readOnly="readOnly"
                                  :moduleId="moduleId"
                                  :searchText="searchText"
                                  :ressourceHeader="ressource"
                                  :fiche="fiche"
                                  :owner=owner
                                  :cart=selectedCart
                                  :route="route"
                                  :attribut="attribut"
                                  @extended="setExtended"
                                  @fullscreen="setFullscreen"
                                  @status="updateStatus"
                                  @selectItem = "selectItem">
          </section-cart-item-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Cart from '@/extend/classes/Cart';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionCartItemList from '@/custom/sections/SectionCartItemList.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionCartItemList,
    FicheHeader,
  },

  props: {
    cart: {
      type: Object as PropType<Cart>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.CART_ITEM_LIST,
      sections: [
        'CART_ITEM_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_CART_ITEM_LIST);
    },

    selectedCart (): Cart {
      return this.cart
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.cart || this.cart.id < 0) && value == 'CART_ITEM_LIST') {
        this.setExtended(new Extended('CART_ITEM_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
